import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import { handleHttpError } from "utils";

import { getCompanyAccountById } from "../../company-accounts";

const apiRoot = process.env.REACT_APP_API_ROOT;

export const onSubmitFactory = ({
  history,
  initUser = () => Promise.resolve({}),
  userPool,
  from
}) => async ({ username: _username, password: _password }) => {
  const authDetails = new AuthenticationDetails({
    Username: _username.toLowerCase(),
    Password: _password
  });
  const cognitoUser = new CognitoUser({
    Username: _username.toLowerCase(),
    Pool: userPool
  });
  let attributes;
  try {
    if (
      _username &&
      !["@enpowered.com", "@getenpowered.com"].some(suffix =>
        _username.includes(suffix)
      )
    ) {
      throw new Error("Email must be an EnPowered account");
    }
    attributes = await new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authDetails, {
        newPasswordRequired: () => {
          reject(new Error("ForceChangePassword"));
        },
        onSuccess: result => {
          const attributes = {
            accessToken: result.getIdToken().getJwtToken()
          };
          cognitoUser.getUserAttributes((err, res) => {
            if (err) reject(err);

            res.map(attr => {
              attributes[attr.Name] = attr.Value;
            });
            resolve(attributes);
          });
        },
        onFailure: err => {
          reject(err);
        }
      });
    });
  } catch (err) {
    // if (err.toString().includes("ForceChangePassword")) {
    //   history.push("/new-password");
    //   return;
    // }
    return Promise.reject(err);
  }

  const {
    accessToken,
    sub: id,
    email,
    email_verified: emailVerified
  } = attributes;

  let res;
  try {
    res = await getMe(accessToken);
  } catch (err) {
    console.log("getMe error", err);
    return;
  }

  const user = await initUser(
    {
      ...res?.data?.attributes,
      id,
      email,
      emailVerified,
      username: _username.toLowerCase()
    },
    getCompanyAccountById
  );

  history.push(from);
  return user;
};

export const getMe = accessToken =>
  fetch(`${apiRoot}/auth/me`, {
    headers: { Authorization: `Bearer ${accessToken}` }
  })
    .then(handleHttpError)
    .then(res => res.json());
